import React from 'react'
import styled from 'styled-components'

export interface ICustomTagProps {
  children?: React.ReactNode
  onClick?: () => void
}

const CustomTag: React.FC<ICustomTagProps> = ({ children, onClick }) => {

  return (
    <Container onClick={onClick}>
      {children}
    </Container>
  )
}


const Container = styled.button`
  cursor: pointer;
  height: 20px;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  padding: 2px 8px;
  color: ${({ theme }) => theme.color.black};
  font-size: ${({ theme }) => theme.size.smaller};
  background-color: transparent;
`


export default CustomTag
